import { themes } from '@/themes'

export function applyThemeSkin(themeSkin) {
    const skin = themeSkin || 'gold'
    if (typeof document !== 'undefined') {
        const root = document.documentElement
        root.setAttribute('data-theme-skin', skin)
        const theme = themes[skin]
        if (theme && theme.cssVars) {
            Object.keys(theme.cssVars).forEach((key) => {
                root.style.setProperty(key, theme.cssVars[key])
            })
        }
    }
    return skin
}
